import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { useApp } from "../context/AppContext";
import { mediaSrcById } from "../api";

const initials = (name) => (name || "").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

/** WhatsApp-style "who reacted" list. Only the viewer's own row is tappable (removes their reaction). */
export function ReactionsSheet({ open, onClose, reactions, participants, onRemoveMine }) {
  const { user, t } = useApp();
  const byId = Object.fromEntries((participants || []).map((p) => [p.id, p]));
  const rows = Object.entries(reactions || {}).flatMap(([emoji, uids]) => uids.map((uid) => ({ emoji, uid })));
  rows.sort((a, b) => (a.uid === user.id ? -1 : b.uid === user.id ? 1 : 0));
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm p-0 overflow-hidden z-[300]" data-testid="reactions-sheet">
        <DialogHeader className="px-4 pt-4 pb-2">
          <DialogTitle className="font-display text-base">{t("reactions")} · {rows.length}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[50vh] overflow-y-auto pb-2">
          {rows.map(({ emoji, uid }) => {
            const p = byId[uid];
            const mine = uid === user.id;
            const name = mine ? t("you") : (p?.name || "…");
            return (
              <button
                key={`${emoji}-${uid}`}
                type="button"
                disabled={!mine}
                onClick={() => { if (mine) { onRemoveMine(emoji); onClose(); } }}
                data-testid={mine ? "reaction-row-mine" : "reaction-row"}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-left ${mine ? "hover:bg-muted active:bg-muted" : "cursor-default"}`}
              >
                <div className="h-9 w-9 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center overflow-hidden shrink-0">
                  {p?.avatar_media_id ? <img src={mediaSrcById(p.avatar_media_id)} alt="" className="h-full w-full object-cover" /> : initials(p?.name || name)}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium truncate">{name}</div>
                  {mine && <div className="text-[11px] text-muted-foreground">{t("tap_to_remove")}</div>}
                </div>
                <span className="text-2xl">{emoji}</span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
